import { Inject, Injectable, InjectionToken, ValueProvider } from '@angular/core';
import { UserService } from '@shared/core';

export interface IUsedeskMessenger {
  show(user: { name: string; email: string }): void;
  hide(): void;
}

class UsedeskMessenger implements IUsedeskMessenger {
  show(params: { name: string; email: string }): void {
    if (!window['usedeskMessenger']) {
      return;
    }

    window['usedeskMessenger'].userIdentify(params);
    window['usedeskMessenger'].toggle(true);
  }

  hide(): void {
    if (!window['usedeskMessenger']) {
      return;
    }

    window['usedeskMessenger'].toggle(false);
  }
}

export const UsedeskMessengerToken: InjectionToken<IUsedeskMessenger> = new InjectionToken<IUsedeskMessenger>(
  'UsedeskMessenger',
);
export const USEDESK_MESSENGER_PROVIDER: ValueProvider = {
  provide: UsedeskMessengerToken,
  useValue: new UsedeskMessenger(),
};

@Injectable({
  providedIn: 'root',
})
export class UsedeskService {
  constructor(@Inject(UsedeskMessengerToken) private usedesk: IUsedeskMessenger, private user: UserService) {}

  showIcon(): void {
    const user = this.user.getUser();

    this.usedesk.show({
      name: user ? `${user.id} ${user.surname} ${user.name}` : '',
      email: user ? user.email : '',
    });
  }

  hideIcon(): void {
    this.usedesk.hide();
  }
}
